module.exports = __webpack_public_path__ + "img/icon-component-label_Activities.50c64243.svg";